export default __webpack_public_path__ + "static/media/edited-7.4e1b68f9.jpg";